<style scoped>
  .project-number{color: #333333;font-size: 14px;margin-left: 40px;display: inline-block;}
  .btn-default{font-size: 14px;color: #00a2e9;display: inline-block;vertical-align:middle}
  .list-panel{background-color: white;padding:0 40px}
  .list-title{color: #464c5b;font-size: 16px;font-weight: bold;}
  .list-schedule{color: #626c70;font-size: 14px;}
  .list-host-text{font-size: 14px;color: #626c70;display: inline-block;margin-right: 19px;vertical-align: text-top;}
  .list-host-avatar{width: 30px;height: 30px;border-radius: 15px;margin-right: 10px;}
  .list-pending{color:#626c70;font-size: 14px;display: inline-block;vertical-align: text-top;margin-top: 4px;}
  .notice-background{background: url("/img/sys/bg13.png");height: 140px;}
  .notice-content{height: 120px;font-size: 14px;color: #657180;margin: 0px 40px;border-bottom: 1px solid #d7dde4;line-height: 30px;display: flex;align-items: center;text-indent:2em}
</style>

<template>
  <div style="background-color: #fff;">
    <Modal
        v-model="noticePanel.state"
        title="编辑公告"
        width="60"
        @on-ok="noticePanel.id?editNotice():saveNotice()"
        @on-cancel="noticePanel = {state:false,content:'',title:'',id:'',}"
        ok-text="发布"
    >
      <Row>
        <Col span="4" style="text-align: right;line-height:32px">公告标题：</Col>
        <Col span="20"><Input v-model="noticePanel.title"></Input></Col>
      </Row>
      <div style="padding: 10px;"></div>
      <Row>
        <Col span="4" style="text-align: right;line-height:32px">公告内容：</Col>
        <Col span="20">
          <!--<Input :rows="6" type="textarea" v-model="noticePanel.content"></Input>-->
          <editor ref="editor" :content="noticePanel.content"></editor>
        </Col>
      </Row>
    </Modal>
    <Row>
      <Col span="24" class="notice-background"></Col>
    </Row>
    <Row style="background-color: #fcfcfc;line-height:80px;">
      <Col span="22">
        <div class="project-number">
          <div style="display: inline-block;padding-right: 10px;">共有<span style="color: #00a2e9;font-size: 24px;">{{list.length}}</span>个公告</div>
          <div style="border-right: 1px solid #e3e3e3;display: inline-block;height: 40px;vertical-align: middle;line-height: 100px;"></div>
        </div>
        <div style="display: inline-block;vertical-align: top;cursor:pointer;" @click="noticePanel.state=true">
          <img style="margin: 0 10px;vertical-align: middle" src="/img/project/add-icon.png"/>
          <p class="btn-default">新建公告</p>
        </div>
      </Col>
    </Row>
    <Row class="notice-content" v-for="(item,index) in list">
        <Col span="20">
          <p style="font-size:18px;color: #464c5b; white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{item.title}}</p>
          <!--<p style="color:rgb(117, 117, 117); white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">公告内容：{{item.content}}</p>-->
          <p style="color:rgb(156,156,156);font-size:12px;">发布时间：{{item.createDate}} 最后修改时间：{{item.updateDate}}</p>
        </Col>
      <Col span="4" style="text-align: center">
        <Button type="primary" @click="noticePanel.state=true;noticePanel.title=item.title;noticePanel.content=item.content;noticePanel.id=item.id">
          编辑
        </Button>
        <span style="margin:5px"></span>
        <Button type="error" @click="deleteNotice(item.id)">
          删除
        </Button>
      </Col>
    </Row>
    <Row>
      <Col span="24" style="padding:0 40px;margin: 40px 0;">
        <Page
            :show-sizer="true"
            :show-total="true"
            @on-page-size-change="search.pageSize=$event;getNotice()"
            :total="search.total"
            :page-size="search.pageSize"
            :page-size-opts="[5,10,15]"
            show-elevator
            @on-change="search.page = $event;getNotice()"
        />
      </Col>
    </Row>
  </div>
</template>

<script>
  import Editor from "../../components/system/editor";
  export default {
    name: "notice",
    components: {Editor},
//公告
    data:function(){
      return{
        noticePanel:{
          state:false,
          content:"",
          title:"",
          id:'',
        },
        search:{
          pageSize: 5,//每页显示多少条
          total: 0,//总条数
          page: 1,//当前页
        },
        list:[]
      }
    },
    methods:{
      deleteNotice:function(id){
        var _this = this
        _this.send({
          headers:'NO/DelNotice',
          confirm:true,
          data:{
            NoticeId:id
          },
          success:function (res) {
            _this.getNotice()
            _this.$Notice.success({
              title:'系统提示',
              desc:'公告已删除！',
            })
          }
        })
      },
      saveNotice:function(){
        var _this = this
        console.log(_this.$refs.editor.getHtml())
        _this.send({
          headers:'NO/AddNotice',
          data:{
            NoticeContent:_this.$refs.editor.getHtml(),
            NoticeTitle:_this.noticePanel.title,
          },
          warningTips:false,
          success:function (res) {
            _this.$Notice.success({
              title:'系统提示',
              desc:'公告发布成功',
            })
            _this.noticePanel = {
              state:false,
              content:"",
              title:"",
              id:'',
            }
            _this.getNotice()
          }
        })
      },
      editNotice:function(){
        var _this = this
        _this.send({
          headers:'NO/EditNotice',
          data:{
            NoticeId:_this.noticePanel.id,
            NoticeContent:_this.$refs.editor.getHtml(),
            NoticeTitle:_this.noticePanel.title,
          },
          warningTips:false,
          success:function (res) {
            _this.$Notice.success({
              title:'系统提示',
              desc:'公告修改成功',
            })
            _this.noticePanel = {
              state:false,
              content:"",
              title:"",
              id:'',
            }
            _this.getNotice()
          }
        })
      },
      getNotice:function(){
        var _this = this
        _this.list = []
        _this.send({
          headers:'NO/ShowNotice',
          data:{
            page : _this.search.page,
            pageSize : _this.search.pageSize,
          },
          warningTips:false,
          success:function (res) {
            _this.search.total = res.count
            for(var index in res.list){
              _this.list.push({
                id:res.list[index].NoticeId,
                title:res.list[index].NoticeTitle,
                content:res.list[index].NoticeContent,
                createDate:res.list[index].NoticeCreatedTime,
                updateDate:res.list[index].NoticeUpdateTime,
              })
            }
          }
        })
      },
    },
    mounted:function () {
      this.getNotice()
    }
  }
</script>
